'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var LANGUAGE_QUERY = 'language:query';
var SINGLE_LANGUAGE_QUERY = 'single-language:query';
var LANGUAGE_COMMAND_CHANGE = 'language:command:change';
var LANGUAGE_UPDATED = 'language:updated';
var VUE_I_18N_QUERY = 'vue:i18n:query';

exports.LANGUAGE_COMMAND_CHANGE = LANGUAGE_COMMAND_CHANGE;
exports.LANGUAGE_QUERY = LANGUAGE_QUERY;
exports.LANGUAGE_UPDATED = LANGUAGE_UPDATED;
exports.SINGLE_LANGUAGE_QUERY = SINGLE_LANGUAGE_QUERY;
exports.VUE_I_18N_QUERY = VUE_I_18N_QUERY;
